import bell_ring_animation from './svg/bell_ring_animation.svg';
import wreath_laurel_dollar_animation from './svg/wreath_laurel_dollar_animation.svg';

const svgs = {
  bell_ring_animation,
  wreath_laurel_dollar_animation,
};

export type SvgAnimatedList = keyof typeof svgs;
export default svgs;
